import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button, Switch, Col, Row, InputNumber } from 'antd';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';
import { createSectionItems, updateSectionItems } from 'services/settings/lookup_table/section';
import { deactivateItem } from 'services/settings/status';
import showDeactivationModal from 'shared_components/deactivation_modal';

const SectionForm = ({ buttonNames, selecetedData, onDrawerClose, onSuccessCreate, onSuccessUpdate, maxSectionSort }) => {
	const [form] = Form.useForm();
	const [isForceDeactivate, setIsForceDeactivate] = useState(false);
	console.log(selecetedData);

	const onFinish = async values => {
		console.log(values);

		const payload = {
			sectionName: values.sectionName ? values.sectionName.toUpperCase() : '',
			sectionCode: values.sectionCode ? values.sectionCode.toUpperCase() : '',
			// For UPDATE: keep existing sort, For CREATE: use maxSectionSort + 1
			sectionSort: selecetedData ? selecetedData.sectionSort : (maxSectionSort ? maxSectionSort + 1 : 1),
			is_active: values.is_active === true ? 1 : 0,
		};

		console.log("🚀 ~ onFinish ~ payload:", payload);
		console.log("🚀 ~ onFinish ~ maxSectionSort:", maxSectionSort);
		console.log("🚀 ~ onFinish ~ selecetedData:", selecetedData);

		if (buttonNames === 'ADD') {
			const created = await createSectionItems(payload);
			if (created) {
				onSuccessCreate();
			}
		} else {
			if (values.is_active === false && isForceDeactivate) {
				await deactivateItem('Section', selecetedData.sectionID);
			}

			payload.sectionID = selecetedData.sectionID;
			const updated = await updateSectionItems(payload);
			if (updated) {
				onSuccessUpdate();
			}
		}
	};

	return (
		<div>
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				initialValues={{
					sectionName: selecetedData ? selecetedData.sectionName : '',
					sectionCode: selecetedData ? selecetedData.sectionCode : '',

					is_active: selecetedData ? (selecetedData.isActive === 1 ? true : false) : true,
				}}
			>
				<Row>
					<Col span={4}>
						<Form.Item>
							<label>ACTIVE:</label>
						</Form.Item>
					</Col>

					<Col span={6}>
						<Form.Item name="is_active" valuePropName="checked">
							<Switch 
								disabled={buttonNames === 'ADD'} 
								onChange={checked => {
									if (!checked) {
										showDeactivationModal('Section', selecetedData.sectionID, {
											itemLabel: 'Section',
											onConfirm: isForce => {
												form.setFieldsValue({ is_active: false });
												setIsForceDeactivate(isForce);
											},
											onCancel: () => {
												form.setFieldsValue({ is_active: true });
												setIsForceDeactivate(false);
											},
										});
									} else {
										setIsForceDeactivate(false);
									}
								}}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Form.Item
					label="SECTION NAME"
					name="sectionName"
					rules={[{ required: true, message: 'This field is required' }]}
				>
					<Input maxLength={254} style={{ textTransform: 'uppercase' }} />
				</Form.Item>
				<Form.Item
					label="SECTION CODE"
					name="sectionCode"
					rules={[{ required: true, message: 'This field is required' }]}
				>
					<Input maxLength={254} style={{ textTransform: 'uppercase' }} />
				</Form.Item>
				{/* <Form.Item
					label="SORT"
					name="sectionSort"
					// rules={[{ required: true, message: 'Please input Departmant name' }]}
				>
					<InputNumber />
				</Form.Item> */}
				<section className="drawerFooter">
					<Button shape="round" onClick={onDrawerClose} style={{ marginRight: 8, width: 120 }}>
						CANCEL
					</Button>
					<Button type="primary" shape="round" style={{ margin: 10, width: 120 }} htmlType="submit">
						{buttonNames}
					</Button>
				</section>
			</Form>
		</div>
	);
};

export default SectionForm;
